import InvoicesTable from "./components/InvoicesTable";
import { UserRoleHeading } from "@/components/Layout/Parts";

const InvoiceList = () => {
  return (
    <>
      <UserRoleHeading />
      <InvoicesTable />
    </>
  );
};

export default InvoiceList;
